import { Paper, Theme, Typography, useMediaQuery } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { MemberResponse } from '../../../shared/types'
import { useSelector } from 'react-redux'
import { getMembers } from '../../../store/data/data.selectors'
import LocationMap from '../../../shared/components/Location/LocationMap'
import { LatLng } from 'leaflet'
import { getAppTheme } from '../../../shared/config/getAppTheme'

const FamilyMap: React.FC = () => {
  const theme: Theme = getAppTheme()
  const downSm = useMediaQuery(theme.breakpoints.down('sm'))

  const members: MemberResponse | undefined = useSelector(getMembers)
  const [positions, setPositions] = useState<LatLng[]>([])
  const [labels, setLabels] = useState<string[]>([])

  useEffect(() => {
    const newPos: LatLng[] = []
    const newLabel: string[] = []
    members?.results.map(member => {
      const stringCoords = member.coordinates?.split(',')
      const coordinates: number[] = []
      stringCoords && stringCoords[0] && coordinates.push(parseFloat(stringCoords[0]))
      stringCoords && stringCoords[1] && coordinates.push(parseFloat(stringCoords[1]))
      const newLatLong = member.coordinates && new LatLng(coordinates[0], coordinates[1])
      if (member.showDetails && newLatLong) {
        if (newPos.findIndex(elem => JSON.stringify(elem) === JSON.stringify(newLatLong)) === -1) {
          newPos.push(newLatLong)
          newLabel.push(`<b>${member.dead ? 'Ruhestätte ' : ''}${member.city}</b><br />${member.firstname} ${member.lastname}`)
        } else {
          const index = newPos.findIndex(elem => JSON.stringify(elem) === JSON.stringify(newLatLong))
          newLabel[index] = newLabel[index] + `<br />${member.firstname} ${member.lastname}`
        }
      }
    })
    setPositions(newPos)
    setLabels(newLabel)
  }, [members])
  return (
    <Paper sx={{ margin: downSm ? '0px' : '32px', padding: downSm ? '8px' : '32px' }}>
      <Typography variant='h1'>Karte der Wohnorte</Typography>
      <Typography variant='body1'>Begib dich auf eine virtuelle Reise durch die Wohnorte unserer Familie und
        lerne die Vielfalt unserer Herkunft kennen.
      </Typography>
      <LocationMap height={500} positions={positions} mapZoom={6} label={labels} />
    </Paper>
  )
}

export default FamilyMap
